// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CarCard_wrap_rA3MA","img":"CarCard_img_1Gloy","text":"CarCard_text_1K-eQ","price_label":"CarCard_price_label_QEG_u","price_value":"CarCard_price_value_szsSd"};